<!-- =========================================================================================
    File Name: ChatContact.vue
    Description: Chat contact - single component for chat
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <div class="chat__contact flex items-center px-2 pt-4 pb-2" :class="{'bg-primary-gradient text-white shadow-lg': isActiveChatUser}">
        <div class="contact__avatar mr-1">
        
            <vs-avatar v-if="contact.image" class="border-2 border-solid border-white coverimg" :src="img_cdn+contact.image" size="42px" />
            <vs-avatar v-else class="border-2 border-solid border-white" size="42px" />
        </div>
        <div class="contact__container w-full flex items-center justify-between overflow-hidden">
            <div class="contact__info flex flex-col truncate w-5/6">
                <h5  v-if="lng === 'dogs'" class="font-semibold" :class="{'text-white': isActiveChatUser}">{{ contact.fname }}</h5>
                <h5  v-else class="font-semibold" :class="{'text-white': isActiveChatUser}">{{ contact.fname }} {{contact.middle_name}} {{contact.lname}}</h5>
                <span class="truncate" v-if="contact.message && contact.message.message">{{contact.message.message}}</span>
            </div>
              <!-- {{msgCounter}} -->
            <div class="chat__contact__meta flex self-start flex-col items-end w-1/6">
                <span class="whitespace-no-wrap" v-if="contact.message && contact.message.created_at">{{ contact.message.created_at | formatDate }}</span>
                <vs-chip class="number" color="primary" v-if="contact.message && contact.message.counter > 0 ">{{contact.message.counter}}</vs-chip>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import {
  STUDENT_LAST_MSG,
  // GET_UNREAD_MESSAGE,
} from '@/graphql'
export default {
  props: {
    contact          : { type: Object,  required: true },
    isActiveChatUser : { type: Boolean },
    lastMessaged     : { type: String,  default : '' },
    showLastMsg      : { type: Boolean, default: false },
    unseenMsg        : { type: Number,  default : 0 },
    meID             : { type: String, required: true}
  },
   computed: {
     msgCounter(){
       return this.msgCount
    },
   },
  watch:{
    isActiveChatUser (val) {
      if (val) {
        if(this.contact.message && this.contact.message.counter){
            this.contact.message.counter=0
        }
      }
    }

  },
  
  filters: {
    formatDate (value) {
      if (value) {
        return   moment(String(value)).format('ll').slice(0, 6).trim()
        
      }
    }
  },
  data () {
    return {
      img_cdn: process.env.VUE_APP_AWS_s3Url+"/",
      last_msg:'',
      lng:'',
      msgCount:0,
    }
  },
  mounted () {
    // Listen for the 'NewMessageNotification' event in the 'synchronized' private channel
    this.$echo.channel('synchronized').listen('NewMessageNotification', (payload) => {
      if (payload) {
        if (payload.type === 'student') {
          if (this.contact.id === payload.message.student_id && this.meID !== payload.message.user_id) {
            if(this.contact.message){
            this.contact.message.counter++
            this.contact.message.message = payload.message.message
            this.contact.message.created_at = payload.message.created_at
            }
           else{
             this.contact.message = payload.message
             this.contact.message['counter'] = 1
          }
          }
  
        }
      }
    })

  },
  created () {
    this.lng = process.env.VUE_APP_I18N_LOCALE
    // this.$apollo
    //   .mutate({
    //     mutation:STUDENT_LAST_MSG,
    //     variables: {
    //       student_id: this.contact.id
    //     }
    //   })
    //   .then(response => {
    //     this.last_msg = response.data.student_last_msg
    //   }).catch(error => {
    //     console.log(error)
    //   })

      // let userId= localStorage.getItem('userId');

      //   this.$apollo
      //     .mutate({
      //       mutation: GET_UNREAD_MESSAGE,
      //       variables: {
      //         student_id: this.contact.id,
      //         user_id:userId,
      //         type:'student'
      //       }
      //     })
      //     .then(response => {
      //       // console.log(response.data.getUnreadChat.counter)
      //       this.msgCount = response.data.getUnreadChat.counter
      //     }).catch(error => {
      //       console.log(error)
      //     })
  }
}

</script>

